// extracted by mini-css-extract-plugin
export default {"tabs":"Tabsbar_tabs__lM+m1"};